// extracted by mini-css-extract-plugin
module.exports = {"view":"Wrapper_view__57OdQ"};